<template lang="pug">
div
    BaseHeader(
        icon='el-icon-plus',
        exibeBotao,
        :titulo='$t("mensagens.regional.labels.titulo")',
        :voltarPara='{ route: "ConfiguracaoRastreabilidade" }',
        :btnTexto='$t("mensagens.regional.labels.novaRegional")',
        @btnHeaderClicado='irParaCadastroGerenteRegional'
    )
    .regionais
        .field
            i.el-icon-search.field__icon
            input.input-search.field__input(
                v-model='filtro',
                type='text',
                :placeholder='$t("mensagens.regional.labels.placeholder")',
                autocomplete='off',
                @keyup.enter='listarRegionais'
            )
        .lista
            h3.lista__titulo {{ $t('mensagens.regional.labels.listagem') }}
            el-table.lista__tabela(:key="listagemTableKey('regionais', lista, paginacao.pagina + 1)", :data='lista')
                el-table-column(
                    prop='nome',
                    :label='$t("mensagens.regional.labels.nomeLabel")'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.nome || '-' }}

                el-table-column(
                    :label='$t("mensagens.regional.labels.acao")',
                    :min-width='15',
                    align='center'
                )
                    .template(slot-scope='scope')
                        el-dropdown.action-button(trigger='click')
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-view',
                                    @click.native='irParaDetalhesRegional(scope.row, true)'
                                ) {{ $t('mensagens.regional.labels.visualizar') }}
                                el-dropdown-item(
                                    icon='el-icon-edit',
                                    @click.native='irParaEdicaoRegional(scope.row)'
                                ) {{ $t('mensagens.regional.labels.editar') }}
                                el-dropdown-item(
                                    icon='el-icon-delete',
                                    @click.native='confirmarRemocaoRegional(scope.row)'
                                ) {{ $t('mensagens.regional.labels.excluir') }}
                template(slot='empty')
                el-empty(description='Não há fornacedores')
            .paginacao
                span.total-paginas {{ formatarTotalPaginas(paginacao.total) }}
                el-pagination(
                    background,
                    layout='prev, pager, next',
                    :page-size='paginacao.itensPorPagina',
                    :current-page.sync='paginacao.pagina + 1',
                    :total='paginacao.total',
                    @current-change='listarRegionais'
                )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import services from '@/services/ContratoOriginacaoService';

export default {
    name: 'Regionais',
    components: {
        BaseHeader
    },
    data() {
        return {
            filtro: '',
            pageable: {
                page: 0,
                size: 10,
                sort: 'nome',
                order: 'asc'
            },
            lista: [],
            paginacao: {}
        };
    },
    mounted() {
        this.listarRegionais();
    },
    methods: {
        async listarRegionais(page = 1) {
            this.pageable.page = page - 1;
            const params = {
                filtro: { nome: this.filtro },
                pageable: this.pageable
            };

            const { data } = await services.buscarRegionalPorFiltro(params);
            this.lista = data.regionais;
            this.paginacao = data.paginacao;
        },
        irParaCadastroGerenteRegional() {
            this.$router.push({
                name: 'RegionalCadastro'
            });
        },
        irParaEdicaoRegional(row) {
            this.$router.push({
                name: 'RegionalEdicao',
                params: { row }
            });
        },
        irParaDetalhesRegional(row) {
            this.$router.push({
                name: 'RegionalDetalhes',
                params: { resume: row }
            });
        },
        confirmarRemocaoRegional(row) {
            const confirmButtonText = this.$t('mensagens.comuns.sim');
            const cancelButtonText = this.$t('mensagens.comuns.cancelar');
            const aviso = this.$t('mensagens.comuns.aviso');
            const mensagemRemocao = this.$t(
                'mensagens.sistema.removerRegional'
            );

            return this.$messageBox
                .confirm(mensagemRemocao, aviso, {
                    confirmButtonText,
                    cancelButtonText,
                    type: 'warning'
                })
                .then(result => {
                    if (result === 'confirm') {
                        this.removerRegional(row);
                    }
                });
        },
        removerRegional(row) {
            const { id, name } = row;
            const mensagemSucesso = this.$t(
                'mensagens.regional.labels.registroExcluido'
            );

            services.removeRegional({ id, name }).then(({ data }) => {
                if (data.includes('sucesso')) {
                    this.$notify.success(mensagemSucesso);
                    this.listarRegionais();
                }
            });
        },
        formatarTotalPaginas(total = 0) {
            const title =
                total > 1
                    ? this.$t('mensagens.regional.labels.titulo')
                    : this.$t('mensagens.regional.labels.tituloSingular');

            return `${total} ${title}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.regionais {
    margin: 20px;
    .field {
        display: flex;
        background-color: $white;
        padding: 7px 10px;
        border-radius: $default-border-radius;
        gap: 5px;
        align-items: center;
        @include default-box-shadow();

        &__icon {
            color: $primary;
        }
        &__input {
            border: none;
            outline: none;
            width: 100%;
            &:focus,
            &:active {
                border: none;
            }
        }
    }
    .lista {
        margin-top: 20px;
        &__titulo {
            margin-bottom: 5px;
        }
        .el-table {
            border-radius: 4px 4px 0 0;
            @include default-box-shadow();
        }
    }
    .paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        background-color: $white;
        border-radius: 0 0 4px 4px;
        padding: 15px;

        .total-paginas {
            color: $primary;
            font-weight: bold;
        }
    }
}
</style>
